<div class="filters" *transloco="let t">
  <header>
    <span>
      {{ t('Filters') }}
      @if (filtersService.isAnyFilterSelected()) {
        <button class="clear-button" (click)="clear.emit(); cancelClick.emit()">
          {{ t('Clear all') }}
        </button>
      }
    </span>

    <button
      app-button="icon-button"
      class="close-button"
      [attr.aria-label]="t('Close filters')"
      (click)="cancelClick.emit()"
    >
      <svg-icon key="close"></svg-icon>
    </button>
  </header>
  <section>
    <app-accordion>
      @if (isMobile()) {
        <details class="sorting" appExpansion>
          <summary>{{ t('Sort by') }}</summary>
          <form>
            <app-form-field>
              <label>
                <input appInput type="radio" name="sorting" [(ngModel)]="sorting" />
                {{ t('Recommended') }}
              </label>
            </app-form-field>
            <app-form-field>
              <label>
                <input
                  appInput
                  type="radio"
                  name="sorting"
                  [(ngModel)]="sorting"
                  value="price"
                />
                {{ t('Price ascending') }}
              </label>
            </app-form-field>
            <app-form-field>
              <label>
                <input
                  appInput
                  type="radio"
                  name="sorting"
                  [(ngModel)]="sorting"
                  value="-price"
                />
                {{ t('Price descending') }}
              </label>
            </app-form-field>
            <app-form-field>
              <label>
                <input
                  appInput
                  type="radio"
                  name="sorting"
                  [(ngModel)]="sorting"
                  value="-created_at"
                />
                {{ t('Newest') }}
              </label>
            </app-form-field>
          </form>
        </details>
      }
      @for (optionType of filters.optionTypes; track optionType.name) {
        <details appExpansion [isOpen]="shouldBeOpen(optionType)">
          <summary [id]="'optionTypeLabel-' + optionType.name">
            {{ optionType.presentation }}
          </summary>
          <div
            [attr.aria-labelledby]="'optionTypeLabel-' + optionType.name"
            role="radiogroup"
          >
            @for (item of optionType.values; track item) {
              <app-form-field>
                <label>
                  <input
                    appInput
                    type="radio"
                    [value]="item"
                    [(ngModel)]="optionType.selectedValue"
                    [name]="optionType.name"
                  />
                  {{ item.presentation }}
                </label>
              </app-form-field>
            }
          </div>
        </details>
      }
      @for (productType of filters.productTypes; track productType) {
        <details appExpansion [isOpen]="shouldBeOpen(productType)">
          <summary [id]="'productTypeLabel-' + productType.name">
            {{ productType.presentation }}
          </summary>
          <div
            [attr.aria-labelledby]="'productTypeLabel-' + productType.name"
            role="radiogroup"
          >
            @for (item of productType.values; track item) {
              <app-form-field>
                <label>
                  <input
                    appInput
                    type="radio"
                    [value]="item"
                    [(ngModel)]="productType.selectedValue"
                    [name]="productType.name"
                  />
                  {{ item.presentation }}
                </label>
              </app-form-field>
            }
          </div>
        </details>
      }
    </app-accordion>
  </section>
  <footer>
    <button app-button (click)="onSave()">{{ t('Show products') }}</button>
  </footer>
</div>
